module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/banner/ko-064cf08f73e272cf3483e0093db00ccf.jpg";